import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledContentAreaColumnWrapper,
  StyledTextWrapper,
  StyledImageWrapper,
} from './styles'

import { LoggedInOutButton } from '../loggedInOutButton'
import { LazyComponent } from '../../atoms/lazyComponent'
import { ResponsiveImage } from '../../atoms/responsiveImage'
import { Text, Title } from '../../atoms/text'

const ContentAreaColumn = (props) => {
  const {
    background_color,
    cta_logged_in,
    cta_logged_out,
    content_area_1_big,
    content_area_1_small,
    image,
  } = props.content

  return (
    <LazyComponent>
      <StyledContentAreaColumnWrapper
        style={{ backgroundColor: background_color }}
      >
        <StyledImageWrapper>
          <ResponsiveImage image={image} big width={300} height={300} />
        </StyledImageWrapper>
        <StyledTextWrapper>
          <Text style={{ color: content_area_1_small.color }}>
            {content_area_1_small.text}
          </Text>
          <Title tagType={'span'} style={{ color: content_area_1_big.color }}>
            {content_area_1_big.text}
          </Title>
        </StyledTextWrapper>
        <LoggedInOutButton
          loggedIn={cta_logged_in}
          loggedOut={cta_logged_out}
          eventId="content-area-column"
        />
      </StyledContentAreaColumnWrapper>
    </LazyComponent>
  )
}

ContentAreaColumn.defaultProps = {
  content: {
    image: {},
    content_area_1_big: {},
    content_area_1_small: {},
    cta: [],
  },
}

ContentAreaColumn.propTypes = {
  content: PropTypes.shape({
    background_color: PropTypes.string,
    image: PropTypes.shape({
      alt: PropTypes.string,
      url: PropTypes.string,
      name: PropTypes.string,
    }),
    content_area_1_small: PropTypes.shape({
      color: PropTypes.string,
      text: PropTypes.string,
    }),
    content_area_1_big: PropTypes.shape({
      color: PropTypes.string,
      text: PropTypes.string,
    }),
    cta_logged_in: PropTypes.arrayOf(
      PropTypes.shape({
        action_text: PropTypes.string,
        link: PropTypes.string,
      })
    ),
    cta_logged_out: PropTypes.arrayOf(
      PropTypes.shape({
        action_text: PropTypes.string,
        link: PropTypes.string,
      })
    ),
  }),
}

export { ContentAreaColumn }
